import React from "react";
import {
  Box,
  Checkbox,
  Chip,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import SourceBadge from "./sourceBadge";

const OpenGapCard = ({
  item,
  checked,
  bulkEditMode,
  editedNote,
  onToggle,
  onNoteChange,
  onEditSingle,
}) => {
  const score = Number(item.ai_confidence || 0);
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: "18px",
        border: "1px solid #f1bcc8",
        background: "#fff7fa",
        position: "relative",
      }}
    >
      <IconButton
        size="small"
        onClick={() => onEditSingle(item)}
        sx={{
          position: "absolute",
          right: 12,
          top: 12,
          width: 32,
          height: 32,
          borderRadius: "10px",
          border: "1px solid #dce3ea",
          background: "#f8fafc",
          color: "#98a2b3",
          "&:hover": {
            background: "#eef2f7",
          },
        }}
      >
        <Edit sx={{ fontSize: 17 }} />
      </IconButton>

      <Stack
        direction="row"
        alignItems="flex-start"
        spacing={1.2}
        sx={{ pr: 5 }}
      >
        <Checkbox
          checked={checked}
          onChange={() => onToggle(item.id)}
          size="small"
          sx={{
            mt: 0.4,
            p: 0.25,
            color: "#7c8594",
            "&.Mui-checked": {
              color: "#93c5fd",
            },
          }}
        />

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box display={"flex"} alignItems={"center"}>
            <SourceBadge item={item} />
            <Chip
              label={item.care_gap_category}
              size="small"
              sx={{
                height: 30,
                borderRadius: "999px",
                background: "#fff7ed",
                border: "1px solid #fdba74",
                color: "#9a3412",
                fontWeight: 700,
                fontSize: 12,
                ml: 2,
                "& .MuiChip-label": {
                  px: 1.5,
                },
              }}
            />
          </Box>

          {item.type !== "AI" && (
            <Typography
              sx={{
                mt: 1,
                fontSize: 11,
                letterSpacing: "0.08em",
                fontWeight: 700,
                color: "#667085",
              }}
            >
              HEDIS / VBC
            </Typography>
          )}

          {!bulkEditMode ? (
            <Typography
              sx={{
                mt: 0.9,
                fontSize: 16,
                lineHeight: 1.5,
                color: "#555",
                fontWeight: 400,
              }}
            >
              {item.text}
            </Typography>
          ) : (
            <TextField
              multiline
              minRows={3}
              fullWidth
              size="small"
              value={editedNote}
              onChange={(e) => onNoteChange(item.id, e.target.value)}
              placeholder="Add or edit note"
              sx={{
                mt: 1,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  background: "#ffffff",
                  alignItems: "flex-start",
                  fontSize: 13,
                  p: 0.5,
                },
              }}
            />
          )}
          <Typography
            sx={{
              mt: 0.9,
              fontSize: 14,
              lineHeight: 1.5,
              color: "#555",
              fontWeight: 400,
            }}
          >
            Detail: {item.care_gap_detials || "N/A"}
          </Typography>
          <Typography
            sx={{
              mt: 0.9,
              fontSize: 14,
              lineHeight: 1.5,
              color: "#555",
              fontWeight: 400,
            }}
          >
            Notes: {item.care_gap_user_notes || "N/A"}
          </Typography>
          <Typography
            sx={{
              mt: 0.9,
              fontSize: 14,
              lineHeight: 1.5,
              color: "#555",
              fontWeight: 400,
            }}
          >
            AI Score: {`${(score * 100).toFixed(0)}%`}
          </Typography>

          {!bulkEditMode && item.notes ? (
            <Typography
              sx={{
                mt: 0.8,
                fontSize: 12,
                color: "#7a7a7a",
              }}
            >
              Note: {item.notes}
            </Typography>
          ) : null}
        </Box>
      </Stack>
    </Box>
  );
};

export default OpenGapCard;
